var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.6667L15.9596 10.7072C16.3501 10.3167 16.3501 9.6835 15.9596 9.29298L15 8.33341",
    stroke: "#5E768D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 10L10.8335 10M3.3335 14.3886V6.05527M13.3335 14.3886C13.3335 15.3091 12.5873 16.0553 11.6668 16.0553H8.3335M13.3335 6.05527C13.3335 5.1348 12.5873 4.38861 11.6668 4.38861H8.3335M4.07566 16.5501L5.74233 17.6612C6.84992 18.3996 8.3335 17.6056 8.3335 16.2744V4.16947C8.3335 2.83831 6.84992 2.04432 5.74233 2.78272L4.07566 3.89383C3.612 4.20294 3.3335 4.72333 3.3335 5.28058V15.1633C3.3335 15.7206 3.612 16.2409 4.07566 16.5501Z",
    stroke: "#5E768D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f6ae5971f908513b47cee7df1f151b85.svg";
export { ForwardRef as ReactComponent };